import { useEffect, useRef } from 'react'
import { motion } from 'motion/react'
import { Col, Container, Row } from 'react-bootstrap'
import { Link, useLocation } from 'react-router-dom'
import animationVariants from '../lib/animationVariants'

export default function ChangeMakers ({ data }) {
  const location = useLocation()
  const { direction } = location.state || {}
  const carouselLoaded = useRef(false)

  function handleCarouselNav (e, dir) {
    const $ = window.$
    $('.change-makers-carousel').flipster(dir)
  }

  useEffect(() => {
    if (location.state) {
      location.state.background = '#1F1F1F'
    } else {
      location.state = {
        background: '#1F1F1F'
      }
    }
  }, [location])

  useEffect(() => {
    const $ = window.$

    if (!carouselLoaded.current) {
      carouselLoaded.current = true
      $('.change-makers-carousel').flipster({
        style: 'flat',
        spacing: -0.25,
        itemContainer: '.flipster-container',
        itemSelector: '.flipster-item',
        touch: true,
        fadeIn: 0
      })
    }
  }, [])

  return (
    <motion.div className='w-100 h-100' variants={animationVariants[direction]} initial='hidden' animate='visible' exit='exit'>
      <Container fluid className='w-100 h-100'>
        <Row as='section' id='change-makers' className='h-100'>
          <Col>
            <Row>
              <Col>
                <p className='intro-text'>Ames Construction began as a small, family-owned business that served a community. Led by the Ames family principals and supported by valued customers, trusted partners and a loyal workforce, today the company is a heavy civil and industrial general contractor that serves a nation.</p>
                <p className='text-center mt-5'>Touch a name to learn more about them.</p>
              </Col>
            </Row>
            <Row>
              <Col>
                <div className='change-makers-carousel pt-5'>
                  <div className='flipster-container'>
                    {data.map((changeMaker, i) => (
                      <div key={`change-maker-${i}`} className='flipster-item'>
                        <Link to={changeMaker.href} state={{ direction: 'right' }}>
                          <img src={changeMaker.img} alt='' className='img-fluid' />
                          <div className='caption p-2 text-center'>
                            {changeMaker.caption}
                          </div>
                        </Link>
                      </div>
                    ))}
                  </div>
                </div>
              </Col>
            </Row>
            <Row>
              <Col className='pb-5'>
                <div className='d-flex justify-content-center align-items-center pt-2'>
                  <div className='flipster-button-previous' onClick={event => handleCarouselNav(event, 'prev')}>
                    <img src='/images/chevron-left.png' alt='' />
                  </div>
                  <div className='flipster-button-next' onClick={event => handleCarouselNav(event, 'next')}>
                    <img src='/images/chevron-right.png' alt='' />
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </motion.div>
  )
}
